import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import mutations from './mutations'
Vue.use(Vuex)
const state = {
  loadingTxt: '',
  personInfo: {},
  makePhotoInfo: {},
  teaminfo: {},
  default_price: {},
  beauty_default: {},
  isIos: false,
  defaultColor: [],
  iosJssdkUrl: '',
  loginState: +sessionStorage.getItem('loginState') || 0, // 1.采用sessionstorage是防止location.href跳转页面时store里该字段属性值被初始化导致循环跳转2.前后端分离在路由守卫做获取code操作并进行登录操作0为未授权1为授权中2为登录成功
  openid: 'omfHj1B99iZAXzpKzi7wnaAsF-44',
  pageStack: [], // 充当页面栈
  actiBol: true // 判断当前页面是push进来的还是返回的来的
  // openid: '2088112351099292'
}
export default new Vuex.Store({
  state,
  actions,
  mutations
})
